import { numero, texto as textoBase, criteriosOrdenados } from "./utils";

const texto = value => textoBase(value, "");
export const tituloRevisao = r => String(r.status || '').startsWith('RECURSO_') || r.tipo === 'RECURSO' ? 'Recurso' : r.tipo === 'NACIONAL' || r.tipo === 'LEGADO_RECUPERADO' ? 'Revalidação Nacional' : 'Revisão técnica da UF';
export const condicaoContato = t => !t.atendimentoRealizado ? 'Não houve atendimento neste contato; os itens não geram pontos.' : t.canal === 'WHATSAPP' && !t.prazoCumprido ? 'O prazo de resposta não foi cumprido neste contato; os itens não geram pontos.' : '';
export function apresentacao(relatorio) {
  const quantidade = relatorio.modalidade === "PARCEIROS" ? 15 : 17;
  return [
    "O Selo Sebrae de Referência em Atendimento foi criado com o objetivo de reconhecer e valorizar as instituições parceiras que se destacam na promoção e no fortalecimento das Salas do Empreendedor e parceiros Sebrae. A atuação das instituições parceiras premiadas serve como referência no esforço contínuo de mobilização para a melhoria da competitividade e no apoio ao desenvolvimento dos pequenos negócios.",
    "As salas do empreendedor e parceiros são avaliadas com base em critérios, incluindo: serviços oferecidos, infraestrutura (física e digital), canais de atendimento, qualidade das equipes de atendimento, entre outros.",
    `A metodologia de concessão do Selo Sebrae de Referência em Atendimento se fundamenta em 7 pilares de avaliação, os quais se desdobram em ${quantidade} critérios específicos. Esses pilares visam avaliar a qualidade e a gestão do atendimento prestado pelas salas do empreendedor.`,
    "A avaliação do atendimento a cada um dos pilares e critérios é realizada a partir da validação das evidências apresentadas pelas instituições parceiras e da aplicação do cliente oculto. A partir dessa análise, são atribuídas pontuações a cada instituição, e a premiação do Selo ocorre em 3 categorias no âmbito estadual (Ouro, Prata e Bronze) e 1 categoria no âmbito nacional (Diamante).",
    "É fundamental que, tanto no processo de coleta de dados quanto na avaliação, haja rigorosa precisão, clareza e transparência das informações. Isso implica que todos os detalhes relevantes do modelo de avaliação sejam devidamente documentados, de forma correta e compreensível.",
  ];
}

const estrutura = c => /estrutura física/i.test(c.nome || "");
const contatoProprio = c => /número de contato próprio/i.test(c.nome || "");
const video = item => /vídeo|video|trajeto/i.test(item.item || "");
const retirarNotaZero = valor => texto(valor).replace(/Pontuação registrada:\s*0(?:[.,]0+)?\.?\s*/gi, "").trim();
export function comentarioAvaliacao(item, criterio) {
  return estrutura(criterio) && video(item) ? retirarNotaZero(item.justificativa) : texto(item.justificativa);
}
export function justificativaCriterio(criterio) {
  let valor = texto(criterio.justificativa);
  if (estrutura(criterio)) (criterio.avaliacoes || []).filter(video).forEach(item => {
    const original = texto(item.justificativa);
    if (original && !(criterio.avaliacoes || []).some(a => !video(a) && texto(a.justificativa) === original)) valor = valor.replace(original, comentarioAvaliacao(item, criterio));
  });
  return valor;
}
export const mostrarPontosNaResposta = c => !estrutura(c) && !contatoProprio(c);
export function nomeItemChecklist(item, criterio) {
  if (!estrutura(criterio)) return item.item;
  if (video(item)) return "Vídeo do trajeto — complemento para a análise dos ambientes externo e interno";
  if (/externo/i.test(item.item || "")) return "Ambiente externo — acesso e identificação da sala";
  if (/interno/i.test(item.item || "")) return "Ambiente interno — espaço e condições de atendimento";
  return item.item;
}
export function fundamentoChecklist(item, criterio) {
  const fundamento = texto(item.justificativa);
  if (estrutura(criterio) && video(item)) return [fundamento, "Documento complementar para a análise dos ambientes externo e interno, sem pontuação própria."].filter(Boolean).join(" ");
  if ((estrutura(criterio) || contatoProprio(criterio)) && Number(item.pontos) > 0) {
    return [fundamento, contatoProprio(criterio) ? `Pontuação atribuída ao conjunto dos requisitos: ${numero(item.pontos)} pontos.` : `Pontuação atribuída a este ambiente: ${numero(item.pontos)} pontos.`].filter(Boolean).join(" ");
  }
  return fundamento;
}
export function textoEvidencia(valor, criterio) {
  const valorTexto = texto(valor);
  return Number(criterio.numero) !== 1 && /cliente oculto/i.test(valorTexto) ? "" : valorTexto;
}

export function decisaoTabelaEvidencia(evidencia, criterio) {
  return Number(criterio.numero) === 5 ? "Análise Realizada" : textoEvidencia(evidencia.status, criterio);
}

export function alternativas(criterio) {
  if (!/cobertura ou produtividade/i.test(criterio.nome || "")) return [];
  return ["Cobertura", "Produtividade"].map((nome, index) => {
    const avaliacao = (criterio.avaliacoes || []).find(a => new RegExp(nome, "i").test(a.item || ""));
    const check = (criterio.checklist || []).find(a => new RegExp(nome, "i").test(a.item || ""));
    // A presença de um item sem resposta não comprova uma avaliação concluída.
    if ((!avaliacao || (typeof avaliacao.atendido !== "boolean" && !avaliacao.justificativa)) && (!check || (typeof check.atendido !== "boolean" && !check.justificativa))) return null;
    return { nome, numero: `${criterio.numero}.${index + 1}`, avaliacao: avaliacao || check, pontos: check ? check.pontos : avaliacao.pontos };
  }).filter(Boolean);
}
export function nomeResumo(criterio) {
  const itens = alternativas(criterio);
  return itens.length ? itens.map(a => `${a.numero}. ${a.nome}`).join("\n") : `${criterio.numero}. ${criterio.nome}`;
}

export function resumoFinal(relatorio) {
  return criteriosOrdenados(relatorio).flatMap(criterio => {
    const opcoes = alternativas(criterio);
    const avaliacoes = opcoes.length ? opcoes.map(a => ({ nome: `${a.numero}. ${a.nome}`, item: a.avaliacao, pontos: a.pontos })) : [{ nome: `${criterio.numero}. ${criterio.nome}`, item: null }];
    return avaliacoes.flatMap(a => {
      let evidencias = criterio.evidencias || [];
      if (a.item && a.item.perguntaId && evidencias.some(e => e.perguntaId)) evidencias = evidencias.filter(e => e.perguntaId === a.item.perguntaId);
      const itens = evidencias.length ? evidencias : [null];
      return itens.map(evidencia => ({ criterio, nome: a.nome, evidencia,
        avaliacao: evidencia ? textoEvidencia(evidencia.status, criterio) : a.item ? (a.item.atendido === true ? "Aprovado" : a.item.atendido === false ? "Não atendido" : "") : texto(criterio.status === "Avaliado sem pontuação" ? "Avaliado" : criterio.status),
        justificativa: evidencia ? textoEvidencia(evidencia.justificativa, criterio) : a.item ? texto(a.item.justificativa) : justificativaCriterio(criterio),
        pontos: a.pontos,
      }));
    });
  });
}
